import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Login.css";
import Products from "./Products"

const Login = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [circle, setCircle] = useState(0);
  const [products, setProducts] = useState(0);
  const history = useHistory();
  const [loginState, setLoginState] = useState(false);

//console.log(" history :: ",history);
//console.log(" his location :: ", history.location);

  const data={
    "username":name,
    "password":password
  }

  // TODO: CRIO_TASK_MODULE_LOGIN - Fetch the API response
  /**
   * Perform the Login API call
   * @param {{ username: string, password: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/login"
   *
   * Example for successful response from backend:
   * HTTP 201
   * {
   *      "success": true,
   *      "token": "testtoken",
   *      "username": "criodo",
   *      "balance": 5000
   * }
   *
   * Example for failed response from backend:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Password is incorrect"
   * }
   *
   */
  const login = async (formData) => {

    const resCondition = validateInput(formData);
    if(resCondition){
      setCircle(1);
      axios.post(`${config.endpoint}/auth/login`, formData)
      .then(response=>{
        console.log("Login response :: ",response);
        enqueueSnackbar('Logged in successfully',{variant:'success'});
        setCircle(0);
        persistLogin(response.data.token, response.data.username, response.data.balance)
        setProducts(1);
        setLoginState(true);
      })
      .catch(res=>{
        // if(er.response.data.message === 'Password is incorrect' || er.response.data.message === 'Username does not exist'){
        //   enqueueSnackbar(er.response.data.message,{variant:'error'});
        //   setCircle(0);
        // }
        // else{
        // console.log("error ::",er);
        // enqueueSnackbar('Something went wrong. Check that the backend is running, reachable and returns valid JSON.',
        // {variant:'error'});
        // setCircle(0);
        // }
        enqueueSnackbar(res.response.data.message,{variant:'error'});
          setCircle(0);
      })
      .catch(er=>{
        // console.log("error ::",er);
        enqueueSnackbar('Something went wrong. Check that the backend is running, reachable and returns valid JSON.',{variant:'error'});
        setCircle(0);
      })
    }
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Validate the input
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false and show warning message if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that password field is not an empty value - "Password is a required field"
   */
  const validateInput = (data) => {
    // console.log("Inside validate ::", data);

    if(data.username === ""){
      enqueueSnackbar('Username is a required field',{variant:'warning'});
      return false;
    }
    if(data.password === ""){
      enqueueSnackbar('Password is a required field',{variant:'warning'});
      return false;
    }
    return true;
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Persist user's login information
  /**
   * Store the login information so that it can be used to identify the user in subsequent API calls
   *
   * @param {string} token
   *    API token used for authentication of requests after logging in
   * @param {string} username
   *    Username of the logged in user
   * @param {string} balance
   *    Wallet balance amount of the logged in user
   *
   * Make use of localStorage: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
   * -    `token` field in localStorage can be used to store the Oauth token
   * -    `username` field in localStorage can be used to store the username that the user is logged in as
   * -    `balance` field in localStorage can be used to store the balance amount in the user's wallet
   */
  const persistLogin = (token, username, balance) => {
    // console.log(`${token}  ${username}   ${balance}`);
    localStorage.setItem("token", token);
    localStorage.setItem("username", username);
    localStorage.setItem("balance", balance);
  };

  return (
    <Box>
      { (products !== 1 )? (<Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={loginState} searchBar={false}/>
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Login</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            type="text"
            name="username"
            value={name}
            onChange={(e)=>{
              setName(e.target.value)
            }}
            required
            placeholder="Username"
            fullWidth
          />
          <TextField 
          id="password"
          label="Password"
          variant="outlined"
          title="Password"
          type="password"
          name="password"
          value={password}
          onChange={(e)=>{
            setPassword(e.target.value)
          }}
          required
          placeholder="Password"
          fullWidth
          />
          {circle === 0 && <Button variant="contained" onClick={()=>{login(data)}}>
            LOGIN TO QKART
            </Button>}
          {circle === 1 && <CircularProgress className="circle"/>}
          <p className="secondary-action">Don’t have an account?{" "}
          {/* <a className="link" href="#">
            Register now
            </a> */}
             <Link to="/register" className="link">Register now</Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>): 
    // (<Purchase />)
    (history.push('/'))
    }
    </Box>
  );
};

export default Login;
